import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		dropdownButton: {
			maxWidth: 300,
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			textTransform: "none",
		},
		line1: {
			fontSize: "0.9em",
			fontWeight: "bold",
			color: "#3a3a3a",
			maxWidth: 125,
			textAlign: "left",
		},
		line2: {
			fontSize: "0.9em",
			color: "#3a3a3a",
			maxWidth: 125,
			textAlign: "left",
		},
		textWrapper: {
			paddingLeft: 10,
		},
		clientIdText: {
			position: "relative" as const,
			zIndex: 1,
			cursor: "pointer",
		},
		menuTextWrapper: {
			display: "flex",
			flexDirection: "column" as const,
			alignItems: "center",
			padding: "8px 16px",
		},
		clientIdRow: {
			display: "flex",
			alignItems: "center",
			gap: 4,
		},
		copyButton: {
			padding: 2,
		},
		signOutMenuItem: {
			padding: "8px 16px",
		},
		signOutButton: {
			width: "100%",
			textTransform: "none",
		},
		menuItemText: {
			paddingLeft: 8,
		},
		paper: {
			width: 240,
		},
		divider: {
			margin: "5px 16px",
		}
	} satisfies Record<string, CSSObject>);
};
